<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      服务商订单管理
      <small>/商品采购下单</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">供应商商品管理</h4>
              </div>
              <!-- end panel-heading -->
              <el-card class="box-card">
                <div>
                  <div class="top-hd">
                    <!-- 1 -->
                    <el-row>
                      <el-form ref="form" :model="form" label-width="100px" style="width: 80%;">
                        <el-col :span="12">
                          <div class="grid-content bg-purple-light">
                            <el-form-item label="订单号：" class="btn1">
                              <el-input
                                v-model="form.orderNo"
                                placeholder="请输入订单号"
                                style="width: 90%;"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="grid-content bg-purple-light">
                            <el-form-item label="客户类型：" class="btn1">
                              <el-select
                                v-model="form.goodname"
                                filterable
                                placeholder="请输入客户类型"
                                style="width: 90%;"
                              >
                                <el-option
                                  v-for="item in options"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="grid-content bg-purple-light">
                            <el-form-item label="订单总数量：" class="btn1">
                              <el-input
                                v-model="form.orderCount"
                                placeholder="请输入订单总数量"
                                style="width: 90%;"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="grid-content bg-purple-light">
                            <el-form-item label="订单总金额：" class="btn1">
                              <el-input
                                v-model="form.orderPrice"
                                placeholder="请输入订单总金额"
                                style="width: 90%;"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light">
                            <el-form-item label="支付凭证：" class="btn1">
                              <div>
                                <el-upload
                                  action
                                  list-type="picture-card"
                                  :http-request="httprequest"
                                  :on-preview="handlePictureCardPreview"
                                  :on-remove="handleRemove"
                                   multiple
                                >
                                  <i class="el-icon-plus"></i>
                                </el-upload>
                                <el-dialog :visible.sync="dialogVisible">
                                  <img width="100%" :src="form.fileUrl" alt />
                                </el-dialog>
                              </div>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="grid-content bg-purple-light"></div>
                        </el-col>
                      </el-form>
                    </el-row>
                  </div>
                  <!-- 03 -->
                  <div>
                    <el-table
                      :data="tableData3"
                      style="width: 100%"
                      size="medium"
                      border
                      :header-cell-style="{background:'#ffffff'}"
                    >
                      <el-table-column
                        width="50"
                        prop="goodsid"
                        label="序号"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="500"
                        prop="companyName"
                        label="企业名称"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="500"
                        prop="goodsName"
                        label="商品名称"
                        align="center"
                        resizable
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        width="500"
                        prop="detailCount"
                        label="下单数量"
                        align="center"
                        resizable
                        show-overflow-tooltip
                        fixed="right"
                      ></el-table-column>
                    </el-table>
                  </div>
                  <!-- 04 -->
                  <div class="bottom">
                    <div class="block">
                      <!---- totalCount  ------- pageSize   ----->
                      <el-pagination
                        :current-page="pageNo"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        background
                      ></el-pagination>
                    </div>
                  </div>

                  <div>
                    <button   class="btn btn-primary btn-sm ButtonColor a_class" @click="submit()">提交</button>
                    <button   class="btn btn-primary btn-sm ButtonColor a_class"  @click="quxiao()">取消</button>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
      <el-dialog title :visible.sync="outerVisible" width="500px">
        <div v-if="EditDialog === 2" class="ModelPadding">
          <div class="swal-icon swal-icon--info"></div>
          <div class="swal-title">您确定吗?</div>
          <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
          <div class="swal-footer">
            <div class="swal-button-container">
              <button
                class="swal-button swal-button--confirm btn btn-primary"
                @click="MakeSure"
                :disabled="disabled"
              >确定</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-default"
                @click="outerVisible = false"
              >取消</div>
            </div>
          </div>
        </div>

        <div></div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
export default {
  name: "topdetail",
  data() {
    return {
      fileList: [{url: ""}],
      dialogImageUrl: "",
      dialogVisible: false,
      srcList: [],
      // 对话框
      EditDialog: 1,
      outerVisible: false,
      // 当前页  ---- 默认显示第几页
      // current: 1,
      pageNo: 1,
      // 当前显示 数据的数据量
      pageSize: 10,
      // 数据总数量  ---- 总条数
      totalCount: 0,

      // 开始时间  （yyyy-MM-dd HH:mm:ss）
      startTime: "",
      // 结束时间  （yyyy-MM-dd HH:mm:ss）
      endTime: "",
      form: {
        orderNo: "",
        // 商品名称
        goodsName: "",
        // 料号
        pznCode: "",

        // 商品名称
        goodname: "",
        // 条形码
        barCode: "",

        //  订单类型
        listtype: "",
        inputTime: "",
        orderPrice: 1,
        orderCount: 0,
        orderStatus: 0,
        fileUrl: ""
      },

      // 订单类型选项
      typeoptions: [
        {
          value: "选项1",
          label: "TOP订单"
        },
        {
          value: "选项2",
          label: "服务商订单"
        },
        {
          value: "选项3",
          label: "分销商订单"
        }
      ],
      //  商品名称
      options: [
        {
          value: "选项1",
          label: "分销商"
        },
        {
          value: "选项2",
          label: "服务商"
        }
      ],

      //  订单状态
      status: [
        {
          value: "选项1",
          label: "待财务审核"
        },
        {
          value: "选项2",
          label: "待运营审核"
        },
        {
          value: "选项3",
          label: "财务审核不通过"
        },
        {
          value: "选项4",
          label: "运营审核不通过"
        },
        {
          value: "选项5",
          label: "运营审核"
        },
        {
          value: "选项6",
          label: "财务审核"
        }
      ],

      rules: {
        TimeValue: [
          {
            required: false,
            message: "请选择查询时间",
            trigger: "change"
          }
        ]
      },
      Formdata: {
        TimeValue: ""
      },
      //   表格的 数据
      tableData3: []
      //
    };
  },
  created() {},
  mounted() {
    // this.initData();
    this.getdata();
  },
  methods: {
    // 获取路由参数
    getdata() {
      this.tableData3 = JSON.parse(localStorage.getItem("userList")).orderInfos;
      this.form.orderNo = JSON.parse(this.$route.query.data).orderNo;
      this.form.orderCount = JSON.parse(this.$route.query.data).orderCount;
      this.totalCount   = this.tableData3.length
    },
    //   列表中的  上传凭证
    httprequest(param) {
      this.dialogImageUrl = URL.createObjectURL(param.file);
      // console.log(this.dialogImageUrl);
      const formData = new FormData();
      formData.append("file", param.file);
      this.fileformData = formData;
      let that = this;
      const options = {
        url: "distribution/FileController/uploadFileToFast",
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        data: formData
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.form.fileUrl = response.data.data;
            that.$notify({
              title: "",
              message: response.data.message,
              type: "success"
            });
            // that.outerVisible = false;
            //  that.percentageShow =  true;
            setTimeout(() => {
              that.percentage = 100;
              that.percentagestatus = "success";
            }, 100);
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 查询数据
    chaxun() {
      if (!this.startTime || !this.endTime) {
        this.$notify({
          title: "失败",
          message: "查询时间不能为空",
          type: "error"
        });
        return;
      } else {
        // 短消息的  中this
        this.initData();
        // this.pageNo = 1
      }
    },
    addc() {
      console.log("批量审核 ");

      // this.$router.push({ name: "addcontract", path: "/addcontract" });
    },
    // 导出数据
    exp() {
      let that = this;
      const options = {
        url: "/statistics/purchaseController/queryExcelPurchaseInfo",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        // 请求参数
        data: Qs.stringify({
          goodName: that.form.goodsName,
          pznCode: that.form.pznCode,
          barCode: that.form.barCode,
          //  开始时间
          beginTime: that.startTime,
          // 结束时间  （yyyy-MM-dd HH:mm:ss）
          endTime: that.endTime
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          }
        })
        .catch(error => {
          http.handleHttpError(error, this);
        });
    },
    //top订单 详情的处理函数
    handleClick(row, index) {
      // this.$router.push({ name: "contractdetail", path: "/contractdetail" });
      console.log(row); //   当前行的值
      console.log(index); //  当前 行
      console.log(row.barCode);
    },
    submit() {
      let that = this;
      const options = {
        // top订单管理
        url: "/distribution/B2cTobOrderController/comOrder",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({
          orderNo: that.form.orderNo,
          fileUrl: that.form.fileUrl,
          orderPrice: that.form.orderPrice,
          companyId: JSON.parse(this.$route.query.data).companyId
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
            localStorage.removeItem("userList")
          that.$notify({
            title: "成功",
            message: response.data.message,
            type: "success"
          });
          that.$router.push({path:"/productList"});
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
    quxiao(){
      localStorage.removeItem("userList")
      this.$router.push({name:"productListadd",path:"/productListadd"})
    },
    // 编辑函数
    edit(item) {
      // this.$router.push({ path: "/editcontract" });
      console.log(item);
      console.log("审核");
    },
    // 对话框的 【确定 】 处理函数
    MakeSure() {
      this.outerVisible = true;
    },
    //   startTime  开始时间
    getstarttime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth() + 1; //得到月份
      var date = now.getDate(); //得到日期
      //   var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒

      if (now.getMonth() + 1) {
        if (month < 10) month = "0" + (now.getMonth() + 1);
        date = "0" + "1";
        hour = "0" + "0";
        minu = "0" + "0";
        sec = "0" + "0";
      }
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    // endtime;结束时间
    getEndtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    //  时间的处理函数
    ChangePicker() {
      if (this.Formdata.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.Formdata.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.Formdata.TimeValue[1]);
      } else if (this.Formdata.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    // 分页处理函数 分页-- 获取 每页  value条
    handleSizeChange(value) {
      this.pageSize = value;
      console.log(this.pageSize);
      this.pageNo = 1;
      this.initData();
    },
    //  获取 当前  value
    handleCurrentChange(value) {
      this.pageNo = value;
      console.log(this.pageNo);
      this.initData();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
.top-hd {
  margin-top: 20px;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.a_class {
  padding: 8px 12px;
}
.box-card {
  width: 100%;
}

.bottom {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.bottom_table {
  display: flex;
  justify-content: flex-start;
}

.grid-content {
  border-radius: 4px;
  min-height: 20px;
}
.top-thone {
  margin-left: 20px;
  margin-top: 20px;
}
.btn1 {
  background-color: #fff;
  margin-left: 20px;
}
.bot-btn {
  float: left;
  margin-left: 48%;
}
.bot-btn-left {
  margin-left: 70px;
}
.top-bot {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/DistributorManage/topadd.vue